import React from 'react';
import './cv.css';

function ME() {
  return (
          <div className='me'>
<h2 className='heading_2'>
        Work Experience
</h2>
<div class="timelines"> 
  <div class="timelines__event  animated fadeInUp delay-3s timelines__event--type1">
    <div class="timelines__event__icon ">
      <i class="lni-cake">
        Dec'21- Jan'22
      </i>

    </div>
    <div class="timelines__event__date">
      RiverMap <br/>Quantitive <br/>Research
    </div>
    <div class="timelines__event__content ">
      <div class="timelines__event__title">
        Research Intern
      </div>
      <div class="timelines__event__description">
        <p> • Devised the labels and keywords for assigning categories in business, financial, and ESG components of financial statements.
            <br/>• Automated the data labeling process for the BERT algorithm to analyze these financial statements </p>
      </div>
    </div>
  </div>
  <div class="timelines__event animated fadeInUp delay-2s timelines__event--type2">
    <div class="timelines__event__icon">
      <i class="lni-burger">
        Jun'21- Aug'21
      </i>
    </div>
    <div class="timelines__event__date">
    RiverMap <br/>Quantitive <br/>Research
    </div>
    <div class="timelines__event__content">
      <div class="timelines__event__title">
        Technology Intern Analyst
      </div>
      <div class="timelines__event__description">
        <p>• Worked as a full-stack developer for the company's new venture to establish an EdTech Platform
        <br/>• Created a lightweight web crawler app that generates the financial portfolio of a firm
        <br/>• Assisted data visualization for a factor analysis platform</p>
      </div>
    </div>
  </div>
  <div class="timelines__event animated fadeInUp delay-1s timelines__event--type3">
    <div class="timelines__event__icon">
      <i class="lni-slim">          Aug'20- Jan'21
</i>
    </div>
    <div class="timelines__event__date">
        Foundation <br/> for Shared <br/>Impact
    </div>
    <div class="timelines__event__content">
      <div class="timelines__event__title">
      CRM Intern
      </div>
      <div class="timelines__event__description">
        <p>• Maintained the databases of FSI and its nine partner companies and helped them move their operation to a more dynamic and user-friendly platform
        <br/>• Prepared the COVID-19 impact report, which involved initial research, conducting interviews with partner companies, and designing the final report
        <br/>• Managed Google Ads marketing campaigns which improved FSI’s website clicks by 30%</p>
      </div>

    </div>
  </div>
  <div class="timelines__event animated fadeInUp timelines__event--type2">
    <div class="timelines__event__icon">
      <i class="lni-cake">Jun'21- Jul'21</i>
    </div>
    <div class="timelines__event__date">
      Change <br/> the <br/> Code
    </div>
    <div class="timelines__event__content">
      <div class="timelines__event__title">
      Technical Instructor
      </div>
      <div class="timelines__event__description">
        <p>• Conducted introductory workshops on Python programming for high school students and interacted with 130 students in total
<br/>• Prepared learning modules used in training sessions</p>
      </div>
    </div>
  </div>
  <div class="timelines__event  animated fadeInUp delay-3s timelines__event--type1">
    <div class="timelines__event__icon ">
      <i class="lni-cake">
        Jul'20- Jul'21
      </i>

    </div>
    <div class="timelines__event__date">
      Women <br/> in <br/>Finance
    </div>
    <div class="timelines__event__content ">
      <div class="timelines__event__title">
        Head of Marketing
      </div>
      <div class="timelines__event__description">
        <p> • Led a subdivision of 10 members and worked on promotion strategies for WiF events like career talks, networking events, and market simulation. The best-performing event had 250+ signups. Through the rigorous promotion cycles, we have inducted 120+ members</p>
      </div>
    </div>
  </div>
</div>
          </div>
  );
}

export default ME;
